var SunGlassBuilder = {
    attributes: {
        disabled: "disabled",
    },
    selectors: {
        steps: "sunglass-builder-step",
        preview: "bundle-options",
        step1Options: "input[name='lens_type']",
        step2Options: "input[name='lens-design']",
        step30ptions: "input[name='choose_add_ons']",
        sunglassBuilderDrawer: "sunglass-builder",
        mobileSummary: "js-mobile-summary",
        backButton: "bundle--back",
        skipButton: "skip-button",
        toggleSummary: "js-toggle-summary",
        step1: "[data-step='1']",
        step2: "[data-step='2']",
        dataStepChanger: "[data-step-changer]",
        addBundleToCart: "add-builder-to-cart",
        builderSubtotal: "js-subtotal",
        progressButtons: "progress_bar-buttons",
        builderClose: "js-closePopup"
    },
    labels: {
        makeSelection: "Make a selection",
        chooseLensDesign: "Choose Lens Design",
        addToCart: "Add to cart",
    },
    elements: function () {
        return {
            preview: document.querySelectorAll(`.${this.selectors.preview}`),
            builderDrawer: document.querySelector(`.${this.selectors.sunglassBuilderDrawer}`),
            allSteps: document.querySelectorAll(`.${this.selectors.steps}`),
            step1Container: document.querySelector(`${this.selectors.step1}`),
            step2Container: document.querySelector(`${this.selectors.step2}`),
            builderSubtotal: document.querySelectorAll(`.${this.selectors.builderSubtotal}`),
            mobileSummary: document.querySelector(`.${this.selectors.mobileSummary}`),
            toggleSummary: document.querySelector(`.${this.selectors.toggleSummary}`),
            dataStepChanger: document.querySelector(`${this.selectors.dataStepChanger}`),
            backButton: document.querySelectorAll(`.${this.selectors.backButton}`),
            skipButtons: document.querySelectorAll(`.${this.selectors.skipButton}`),
            addBundleToCartBtn: document.querySelector(`.${this.selectors.addBundleToCart}`),
            progressButtons: document.querySelectorAll(`.${this.selectors.progressButtons}`),
            products: JSON.parse(document.querySelector("#sunglass_builder").innerText),
            variantPicker: document.querySelector('product-variants'),
            builderCloseBtn: document.querySelector(`.${this.selectors.builderClose}`),
            lensTypes : ["sv","prg","np"],
            singleVisionSunProduct: JSON.parse(document.querySelector(".js-single-vision-sun-product").innerText),
            progressiveSunProduct: JSON.parse(document.querySelector(".js-progressive-sun-product").innerText),
            nonPrescriptionSunProduct: JSON.parse(document.querySelector(".js-non-prescription-sun-product").innerText)
        };
    },
    init: function () {
        if (!document.querySelector(".sunglass-builder")) return;
        this.bindEvents();
    },
    state: {
        currentStep: 1,
        prevStep: 0,
        stepCount: 1,
        step1Value: false,
        step2Value: false,
        step1AddOnsValue: false,
        number_of_steps: false,
    },

    bindEvents: function () {
        console.log(this.elements().builderCloseBtn);
        let _ = this;
        this.elements().step1Container.querySelectorAll(this.selectors.step1Options).forEach((step1option) => step1option.addEventListener("change", _.handleStep1Change.bind(this), true));
        this.elements().step1Container.querySelector(this.selectors.step30ptions).addEventListener("change", _.handleStep1addOnsChange.bind(this), true);
        this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step3option) => step3option.addEventListener("change", _.handleStep2Change.bind(this), true));
        this.elements().dataStepChanger.addEventListener("click", _.handleNextClick.bind(this), true);
        this.elements().addBundleToCartBtn.addEventListener('click', _.handleAddToCart.bind(this), true);
        this.elements().backButton.forEach((backButton) => backButton.addEventListener("click", _.handleBackClick.bind(this), true));
        this.elements().progressButtons.forEach((progressButtons) => progressButtons.addEventListener("click", _.handleProgressButtonClick.bind(this), true));
        this.elements().toggleSummary.addEventListener("click", _.handleSummaryToggle.bind(this), true);
        this.elements().builderCloseBtn.addEventListener('click', _.resetBuilder.bind(this), true);

        if (this.elements().products["progressive_vision_tint"] || this.elements().products["single_vision_tint"]) {
            this.elements().step1Container.querySelector(".lense_add_ons_main").classList.add("hidden");
        }
    },
    handleSummaryToggle: function () {
        this.elements().mobileSummary.classList.toggle("is-active");
    },
    handleStep1Change: function ({ currentTarget }) {
        let selectedVariant = this.elements().variantPicker.selectedVariant;
        let Polarization = this.elements().products.Polarization[selectedVariant.id];
        this.state.step1Value = { title: currentTarget.value, data: currentTarget.getAttribute('data-value'), price: parseInt(currentTarget.getAttribute("data-price")) };
        // console.log(this.state.step1Value , currentTarget)
        // console.log( this.elements().step2Container.querySelectorAll(".not-high-index"));
        // this.elements().step2Container.querySelectorAll(".not-high-index").forEach((element) => element.classList.remove('hidden'));
        console.log(this.state,this.state.step1Value.data,this.elements().products)
        if (this.state.step1Value.data === "sv") {
            this.elements().step2Container.querySelectorAll(".step-lens-design").forEach((element) => element.classList.add("hidden"));
            this.elements().step2Container.querySelectorAll(".step-lens-design.for-single-vision").forEach((element) => element.classList.remove("hidden"));
            // this.elements().step1Container.querySelector(".lense_add_ons_main").classList.remove("hidden");
            // if (this.elements().products["progressive_vision_tint"] || this.elements().products["single_vision_tint"]) {
            //     this.elements().step1Container.querySelector(".lense_add_ons_main").classList.add("hidden");
            // }

        }

        if (this.state.step1Value.data === "prg") {
            this.elements().step2Container.querySelectorAll(".step-lens-design").forEach((element) => element.classList.add("hidden"));
            this.elements().step2Container.querySelectorAll(".step-lens-design.for-progressive-prescription").forEach((element) => element.classList.remove("hidden"));
            // this.elements().step1Container.querySelector(".lense_add_ons_main").classList.remove("hidden");
            // if (this.elements().products["progressive_vision_tint"] || this.elements().products["single_vision_tint"]) {
            //     this.elements().step1Container.querySelector(".lense_add_ons_main").classList.add("hidden");
            // }
        }
        if (this.state.step1Value.data === "np") {

            // this.elements().step1Container.querySelector(".lense_add_ons_main").classList.add("hidden");
            this.elements().step1Container.querySelector(this.selectors.step30ptions).checked = false;
            this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.add("tw-invisible");
            this.elements().step1Container.querySelector(".addons-step1").classList.remove("hidden");
        }

        let stepsData = ["sv","prg","np"];
        console.log("----->>>>>>>", Polarization,this.state.step1Value.data,stepsData,!((Polarization.disabledPolarization != "true") && stepsData.includes(this.state.step1Value.data) == true))
        if((Polarization.disabledPolarization != "true") && stepsData.includes(this.state.step1Value.data) == true && Polarization.product != 'null'){
            this.elements().step1Container.querySelector(".lense_add_ons_main").classList.remove("hidden");
        }else{
            this.elements().step1Container.querySelector(".lense_add_ons_main").classList.add("hidden");
        }

        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.remove("tw-invisible");

        // Reset all next steps
        // Step2 Reset
        this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);


        this.changeButtonState();
        this.state.step2Value = false;
        // document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
        // document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
    },
    handleStep1addOnsChange: function ({ currentTarget }) {
        let _ = this;
        // console.log(_.elements().step1Container.querySelector(_.selectors.step30ptions).checked)
        console.log('>>> handleStep1addOnsChange :: ',this.state.step1Value.data);
        if (_.elements().step1Container.querySelector(_.selectors.step30ptions).checked) {

            if(this.elements().lensTypes.includes(this.state.step1Value.data)){
                this.state.step1AddOnsValue = { title: currentTarget.value, data: currentTarget.getAttribute('data-value'), price: parseInt(currentTarget.getAttribute("data-price")) };
            }

            /*if (this.state.step1Value.data === "sv") {
                this.state.step1AddOnsValue = { title: currentTarget.value, data: currentTarget.getAttribute('data-value'), price: parseInt(currentTarget.getAttribute("data-price")) };
                // console.log("currentTarget", this.state.step1AddOnsValue)
            }
            if (this.state.step1Value.data === "prg") {
                this.state.step1AddOnsValue = { title: currentTarget.value, data: currentTarget.getAttribute('data-value'), price: parseInt(currentTarget.getAttribute("data-price")) };
                // console.log("currentTarget", this.state.step1AddOnsValue)
            }*/
        }
        // this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
        // document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
        this.state.step2Value = false;
        this.updatePreview();
    },
    handleStep2Change: function ({ currentTarget }) {
        this.state.step2Value = { title: currentTarget.getAttribute("value"), value: currentTarget.getAttribute("data-value"), price: parseInt(currentTarget.getAttribute("data-price")) };
        this.elements().step2Container.querySelector(".progress-bar-wrapper").classList.remove("tw-invisible");
        document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
        this.changeButtonState();
        // console.log(this.state);
    },
    handleBackClick: function ({ currentTarget }) {
        if (this.state.currentStep != 1) {
            document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='${this.state.currentStep}']`).forEach((progressButton) => progressButton.setAttribute("disabled", ""));
        }
        this.state.currentStep = this.state.currentStep - 1;
        this.handleStepChange("prev");
    },

    handleNextClick: function () {
        this.state.currentStep = this.state.currentStep + 1;
        this.handleStepChange("next");
    },
    handleProgressButtonClick: function ({ currentTarget }) {
        if (currentTarget.hasAttribute("disabled")) {
            return;
        }
        if (this.state.currentStep != 1) {
            document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='${this.state.currentStep}']`).forEach((progressButton) => progressButton.setAttribute("disabled", ""));
        }
        this.state.currentStep = parseInt(currentTarget.getAttribute('data-progress'));
        this.handleStepChange();
    },

    handleStepChange: function () {
        this.elements().allSteps.forEach((step) => step.classList.add("hidden"));
        let button = this.elements().dataStepChanger;
        let addToCart = this.elements().addBundleToCartBtn;

        const enableButton = (isFinal) => {
            button.removeAttribute(this.attributes.disabled, true);
            isFinal ? (button.classList.add("hidden"), addToCart.classList.remove("hidden")) : (button.classList.remove("hidden"), addToCart.classList.add("hidden"));
        };

        const disableButton = () => {
            button.setAttribute(this.attributes.disabled, true);
            button.querySelector(".button-text").innerText = this.labels.makeSelection;
        };

        const firstImage = document.querySelector(".js-builder-image:not(.hidden)[data-current-index='1']");
        const secondImage = document.querySelector(".js-builder-image:not(.hidden)[data-current-index='2']");
        if (this.state.currentStep % 2 === 0) {
            secondImage && secondImage.classList.add("is-selected");
            if (secondImage) {
                firstImage && firstImage.classList.remove("is-selected");
            }
        } else {
            secondImage && secondImage.classList.remove("is-selected");
            firstImage && firstImage.classList.add("is-selected");
        }

        switch (this.state.currentStep) {
            case 1: {
                this.elements().step1Container.classList.remove("hidden");
                if (this.state.step1Value.data === "sv" || this.state.step1Value.data === "prg") {
                    button.querySelector(".button-text").innerText = this.labels.chooseLensDesign;
                }
                this.state.step1Value ? enableButton() : disableButton();
                if (this.state.step1Value && this.state.step1Value.title === "non-prescription") {
                    enableButton(true);
                }

                this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelectorAll(".progress-bar-options").forEach((progressBarOptions) => progressBarOptions.classList.add("hidden"));
                this.elements().step2Container.querySelector(".progress-bar-wrapper").querySelectorAll(".progress-bar-options").forEach((progressBarOptions) => progressBarOptions.classList.add("hidden"));

                if (this.state.step1Value.data === "sv" || this.state.step1Value.data === "prg") {
                    this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
                    this.elements().step2Container.querySelector(".progress-bar-wrapper").querySelector(".addons-step1").classList.remove("hidden");
                    this.elements().step1Container.querySelector(".progress_bar").classList.remove("hidden");
                }

                if (this.state.step1Value.data === "np") {
                    this.elements().step1Container.querySelector(this.selectors.step30ptions).checked = false;
                    this.elements().step1Container.querySelector(".progress_bar").classList.add("hidden");
                    this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.add("tw-invisible");
                    this.elements().step1Container.querySelector(".addons-step1").classList.remove("hidden");
                    this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
                    this.state.step2Value = false;
                }

                this.state.step2Value = false;
                this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
                break;
            }
            case 2: {
                this.elements().step2Container.classList.remove("hidden");
                document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
                document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='${this.state.currentStep}']`).forEach((progressButton) => progressButton.removeAttribute("disabled"));
                button.querySelector(".button-text").innerText = this.labels.addToCart;
                if (this.state.step1Value.data === "rr") {
                    this.state.step2Value ? enableButton(true) : disableButton();
                } else if (this.state.step1Value.data === "np") {
                    console.log("11111")
                    enableButton(true);

                } else {
                    this.state.step2Value ? enableButton(true) : disableButton();

                }
                // enableButton(true);
                break;
            }
            case 3: {
                this.elements().step2Container.classList.remove("hidden");
                this.state.step2Value ? enableButton(true) : disableButton();
                // enableButton(true);
                break;
            }
            default:
                this.elements().builderDrawer.removeAttribute("open");
                this.elements().step1Container.classList.remove("hidden");
                this.resetBuilder();
                disableButton();
                break;
        }
        this.updatePreview();
    },

    resetBuilder: function () {
        console.log("Reset the builder");

        // Reset the builder state
        this.state = {
            currentStep: 1,
            prevStep: 0,
            stepCount: 1,
            step1Value: false,
            step2Value: false,
            step1AddOnsValue: false,
            number_of_steps: false,
        };

        // Step 1 reset
        this.elements().allSteps.forEach((step) => step.classList.add("hidden"));
        this.elements().allSteps.forEach((step, index) => index === 0 && step.classList.remove("hidden"));
        this.elements().step1Container.querySelectorAll(this.selectors.step1Options).forEach((step1option) => step1option.checked = false);
        this.elements().allSteps.forEach((step) => step.querySelector(".progress-bar-wrapper").classList.add("tw-invisible"));
        this.elements().step1Container.querySelector(".progress-bar-wrapper").classList.remove("tw-invisible");
        this.elements().step1Container.querySelector(".progress_bar").classList.remove("hidden");
        this.elements().step1Container.querySelector(this.selectors.step30ptions).checked = false;
        this.elements().step1Container.querySelector(".progress-bar-wrapper").querySelectorAll(".progress-bar-options").forEach((progressBarOption) => {
            if (progressBarOption) {

                progressBarOption.querySelectorAll(".progress_bar-buttons").forEach(function (eleme) {
                    if (eleme.getAttribute("data-progress") == "2" || eleme.getAttribute("data-progress") == 3) {
                        eleme.setAttribute("disabled", "");
                    }
                })
            }

            // document.querySelector(".sunglass-builder__wrapper").querySelectorAll(`.${this.selectors.progressButtons}[data-progress='2']`).forEach((progressButton) => progressButton.setAttribute("disabled"));
        });
        // Step 2 reset
        this.elements().step1Container.querySelector(".lense_add_ons_main").classList.add("hidden");
        this.elements().step2Container.querySelectorAll(this.selectors.step2Options).forEach((step2option) => step2option.checked = false);
        document.querySelectorAll(".lens-selection").forEach((lensSelection) => lensSelection.classList.add('hidden'));
        this.updatePreview();
    },
    changeButtonState: function () {
        let button = this.elements().dataStepChanger;
        let currentStep = this.state.currentStep;
        button.setAttribute(this.attributes.disabled, true);
        button.querySelector(".button-text").innerText = this.labels.makeSelection;


        this.handleStepChange();
    },
    handleAddToCart: function () {
        let _ = this;
        let button = this.elements().addBundleToCartBtn;
        const bundleId = (new Date()).getTime();
        let itemsArray = [];
        // console.log("Adding product to cart!", this);
        let selectedVariant = this.elements().variantPicker.selectedVariant;

        button.setAttribute('aria-busy',true);

        const generateSku = () => {
            let step2Values = this.state.step2Value ? (this.state.step2Value.data) : false;
            console.log(">> generateSku :: ",this.state.step1Value.data, this.state)
            if (this.elements().products["progressive_vision_tint"] || this.elements().products["single_vision_tint"] || this.elements().products["non_prescription_tint"]) {
                return `cmt-${this.state.step1Value.data}${(this.state.step2Value) ? `-${this.state.step2Value.value}` : ``}${step2Values ? `-${step2Values}` : ``}${this.state.step1AddOnsValue ? `-${this.state.step1AddOnsValue.data}` : ``}`;
            }
            return `sun-${this.state.step1Value.data}${(this.state.step2Value) ? `-${this.state.step2Value.value}` : ``}${step2Values ? `-${step2Values}` : ``}${this.state.step1AddOnsValue ? `-${this.state.step1AddOnsValue.data}` : ``}`;
        };

        let selectedSku = generateSku();
        console.log(">>> Generated Sku", selectedSku,this.state.step1AddOnsValue);

        let opticalProduct = false, giftWithPurchase = false;

        let gwpProperties = { _bundle_id: bundleId, _isgift: true }

        if(this.elements().products.gwp_mto != "" && this.elements().products.gwp_mto != null) {
            gwpProperties._mto = this.elements().products.gwp_mto;
        }

        if (this.elements().products.gwp) {
            itemsArray.push({
                id: this.elements().products.gwp.variants[0].id,
                quantity: 1,
                properties: gwpProperties
            })
        }


        // if (this.state.step1Value.data === "sv" || this.state.step1Value.data === "prg") {}

        if(this.elements().lensTypes.includes(this.state.step1Value.data)){
            let Polarization =  this.elements().products.Polarization[selectedVariant.id];
            // console.log("Single Vision");
            // this.elements().products["single_vision_tint"] : this.elements().products["progressive_vision_tint"]
            opticalProduct = this.state.step1Value.data === "sv" ? this.elements().products["single_vision_sun"] : (this.state.step1Value.data == "np") ? this.elements().products["non_prescription_sun"] : this.elements().products["progressive_vision_sun"];
            if (this.elements().products["single_vision_tint"] || this.elements().products["progressive_vision_tint"] ||  this.elements().products["non_prescription_tint"]) {
                opticalProduct = this.state.step1Value.data === "sv" ? this.elements().products["single_vision_tint"] : (this.state.step1Value.data == "np") ? this.elements().products["non_prescription_tint"] : this.elements().products["progressive_vision_tint"];
            }
            if (opticalProduct) {
                let gwpProduct = false;
                let mto = "";
                if (this.elements().products["single_vision_tint"] || this.elements().products["progressive_vision_tint"] ||  this.elements().products["non_prescription_tint"]) {
                    if(this.state.step1Value.data === "sv" && this.elements().products["single_vision_tint_gwp"] != null) {
                        gwpProduct = this.elements().products["single_vision_tint_gwp"];
                        mto = this.elements().products["single_vision_tint_mto"];
                    }else if(this.state.step1Value.data === "prg" && this.elements().products["progressive_vision_tint_gwp"] != null) {
                        gwpProduct = this.elements().products["progressive_vision_tint_gwp"];
                        mto = this.elements().products["progressive_vision_tint_mto"];
                    }else if(this.state.step1Value.data === "np" && this.elements().products["non_prescription_tint_gwp"] != null) {
                        gwpProduct = this.elements().products["non_prescription_tint_gwp"];
                        mto = this.elements().products["non_prescription_tint_mto"];
                    }
                }else{
                    if(this.state.step1Value.data === "sv" && this.elements().products["single_vision_sun_gwp"] != null) {
                        gwpProduct = this.elements().products["single_vision_sun_gwp"];
                        mto = this.elements().products["single_vision_sun_mto"];
                    }else if(this.state.step1Value.data === "prg" && this.elements().products["progressive_vision_sun_gwp"] != null) {
                        gwpProduct = this.elements().products["progressive_vision_sun_gwp"];
                        mto = this.elements().products["progressive_vision_sun_mto"];
                    }else if(this.state.step1Value.data === "np" && this.elements().products["non_prescription_sun_gwp"] != null) {
                        gwpProduct = this.elements().products["non_prescription_sun_gwp"];
                        mto = this.elements().products["non_prescription_sun_mto"];
                    }
                }

                let gwpBundleProperties = { 
                    _bundle_id: bundleId
                }

                if(mto != "" && mto != null) {
                    gwpBundleProperties._mto = mto;
                }

                if (gwpProduct) {
                    itemsArray.push({ 
                        id: gwpProduct.variants[0].id, 
                        quantity: 1, 
                        properties: gwpBundleProperties
                    });
                }
            }
            // console.log("opticalProduct :: ",opticalProduct)
            if (this.state.step1AddOnsValue.data == "po" && Polarization.product != "null" && this.state.step1Value.data == "np") {
                
                let bundleProperty = { 
                    _bundle_id: bundleId, 
                    // type: (this.state.step1Value.data == "np") ? "non-prescription" : "prescription" 
                } 
                if(Polarization.polarization_product_mto != "") {
                    bundleProperty._mto = Polarization.polarization_product_mto;
                }

                let itemData = { 
                    id: Polarization.product, 
                    quantity: 1, 
                    properties: bundleProperty
                }
                itemsArray.push(itemData);
            }else{
                if (opticalProduct) {
    
                    let opticalVariant = opticalProduct.variants.find((variant) => variant.sku === selectedSku) || false;
                    // console.log("Single Vision", opticalVariant);
                    if (opticalVariant) {
                        
                        let itemProperties = {
                            _bundle_id: bundleId, 
                            type: (this.state.step1Value.data == "np") ? "non-prescription" : "prescription"
                        }
                        
                        let sunglassProdScript = document.querySelector(`[data-sun-product-id="${opticalVariant.featured_image.product_id}"]`)
                        if(sunglassProdScript) {
                            let sunglassProd = JSON.parse(sunglassProdScript.innerText);
                            if (sunglassProd[opticalVariant.id] != null && sunglassProd[opticalVariant.id] !== "") {
                                itemProperties._mto = sunglassProd[opticalVariant.id];
                            }
                        }

                        let itemData = { 
                            id: opticalVariant.id, 
                            quantity: 1, 
                            properties: itemProperties
                        }
                        // if(this.state.step1AddOnsValue.data == "po" && Polarization.skuProperty != "" && this.state.step1Value.data == "np"){
                        //     itemData.properties['Polarized SKU'] = Polarization.skuProperty;
                        // }
                        itemsArray.push(itemData);
                    }
                }
            }
        }

        // console.log(selectedVariant);

        let sunglassMtoValue = "";
        let sunglassMtoScript = document.querySelector('[mto-sunglass-variant-json]');
        if(sunglassMtoScript) {
            let sunglassMtoData = JSON.parse(sunglassMtoScript.textContent);
            sunglassMtoValue = sunglassMtoData[selectedVariant.id] || "";
        }

        let bundleProperties = { _main_bundle_id: bundleId };
        if (sunglassMtoValue !== "") {
            bundleProperties._mto = sunglassMtoValue;
        }

        itemsArray.push({ id: selectedVariant.id, quantity: 1, properties: bundleProperties });

        const data = { items: itemsArray };
        // console.log(">>> data :",data);

        fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(data) })
            .then(response => (Promise.all([response, fetch(`${window.Shopify.routes.root}cart.js`, { method: 'GET' }),])))
            .then(([response1, response2]) => Promise.all([response1.json(), response2.json()]))
            .then(([response, cart]) => {
                if (response.status) {
                    console.error("Product cannot be added", response);
                    document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                        bubbles: true,
                        cancelable: true,
                        detail: {
                            status: response.ok ? "success" : "error",
                            error: response["description"] || ""
                        }
                    }));
                    button.removeAttribute('aria-busy');
                    return;
                }
                button.removeAttribute('aria-busy');

                document.querySelector("drawer-content").open = false;
                document.querySelector("popover-content").open = false;
                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                        cart: cart
                    }
                }));
                if (document.getElementById('mini-cart') && window.themeVariables.settings.cartType != "message") {
                    document.getElementById('mini-cart').open = true;
                }
                else if (window.themeVariables.settings.cartType == "message") {
                  document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
                    bubbles: true,
                    cancelable: true,
                    detail: {
                        status: "success",
                        error: ""
                    }
                  }));
                }
                else {
                    window.location.href = `${window.Shopify.routes.root}cart`
                }
                _.resetBuilder();
            });
    },

    updatePreview: function () {
        // console.log("Updating preview", this.state);
        this.elements().preview.forEach((previewSection) => {
            previewSection.innerHTML = ""
        });
        let previewHtml = ``;

        if (this.state.step1Value) {
            previewHtml += `<p class="options"><span class="option option-name">Lens Type: </span><span class="option option-value">${this.state.step1Value.title.replaceAll("-", " ")}</span></p>`;
        }
        if (this.state.step1AddOnsValue.data === "po" && this.elements().step1Container.querySelector(this.selectors.step30ptions).checked && this.state.step1Value && this.state.step1Value.data !== "np") {
            previewHtml += `<p class="options"><span class="option option-name">Add-ons: </span><span class="option option-value">${this.state.step1AddOnsValue.title}</span></p>`;
        }

        if (this.state.step2Value) {
            previewHtml += `<p class="options"><span class="option option-name">Lens Design: </span><span class="option option-value">${this.state.step2Value.title}</span></p>`;
        }
        if (previewHtml.length) {
            this.elements().preview.forEach((previewSection) => {
                previewSection.closest(".lens-selection") ? previewSection.closest(".lens-selection").classList.remove("hidden") : "";
            });
            // this.elements().preview.closest(".lens-selection").classList.remove("hidden");
        }

        this.elements().preview.forEach((previewSection) => {
            previewSection.innerHTML = previewHtml
        });
        // this.elements().preview.innerHTML = previewHtml;

        let selectedVariant = this.elements().variantPicker.selectedVariant;
        let subTotal = selectedVariant.price;
        if (this.state.step1Value) {
            subTotal += this.state.step1Value.price;
            // console.log("After step1", subTotal);
        }
        if (this.state.step1AddOnsValue && this.elements().step1Container.querySelector(this.selectors.step30ptions).checked) {
            // console.log("this.state.step1AddOnsValue.price", this.state.step1AddOnsValue.price)
            subTotal += this.state.step1AddOnsValue.price;
            // console.log("After step1", subTotal);
        }


        if (this.state.step2Value) {
            subTotal += this.state.step2Value.price;
            // console.log("After step3", subTotal);
        }

        // console.log("Subtotal", subTotal);
        const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
        this.elements().builderSubtotal.forEach((subtotalElement) => {
            let builderSubtotal = `<span class="price price--large"><span class="visually-hidden">Sale price</span>${window.formatMoney(subTotal, currencyFormat)}</span>`;
            subtotalElement.innerHTML = builderSubtotal;
        })
        if (!this.elements().addBundleToCartBtn.classList.contains("hidden")) {
            let buttonPriceElement = document.createElement('span');
            buttonPriceElement.classList.add('js-btn-subtotal-text');
            buttonPriceElement.innerHTML = `<span> - </span><span class="price price--small"><span class="visually-hidden">Sale price</span>${window.formatMoney(subTotal, currencyFormat)}</span>`;
            if(this.elements().addBundleToCartBtn.querySelector('.js-btn-subtotal-text')) this.elements().addBundleToCartBtn.querySelector('.js-btn-subtotal-text').remove();
            this.elements().addBundleToCartBtn.querySelector('.loader-button__text').appendChild(buttonPriceElement);
        }
    },
}
SunGlassBuilder.init();